import HeaderNotification from '../headerNotification'
import { StyledBody, StyledContent, StyledHeader } from './index.styled'
import { ArrowUpOutlined } from '@ant-design/icons'
import cn from 'classnames'
import { FC, ReactNode, useRef } from 'react'
import styled from 'styled-components'

export type HeaderBarProps = {
  headerTitle?: string | ReactNode
  headerDescription?: string
  headerComponent?: ReactNode
  stickyHeader?: boolean
  bgColor?: string
  showArrow?: boolean
}
const StyleArrowUp = styled.div`
  position: fixed;
  bottom: 2%;
  right: 2%;
  background: var(--color-primary-104);
  color: var(--color-primary-108);
  font-size: 20px;
  font-weight: bold;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  text-align: center;
  align-content: center;
  cursor: pointer;
  z-index: 1000;
`
const MainHeader: FC<HeaderBarProps> = ({
  headerTitle,
  headerDescription,
  headerComponent,
  stickyHeader,
  bgColor = 'var(--color-background)',
  children,
  showArrow = false,
  ...props
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const handleScrollToTop = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
  return (
    <StyledContent
      ref={containerRef}
      className="layout-main-header"
      style={{ backgroundColor: bgColor }}
      {...props}>
      <StyledHeader className={cn('main--header', { stickyHeader })}>
        {headerComponent ? (
          headerComponent
        ) : (
          <HeaderNotification
            title={headerTitle}
            description={headerDescription}
          />
        )}
      </StyledHeader>
      <StyledBody>{children}</StyledBody>
      {showArrow && (
        <StyleArrowUp onClick={handleScrollToTop}>
          <ArrowUpOutlined />
        </StyleArrowUp>
      )}
    </StyledContent>
  )
}

export default MainHeader
